import { FETCH_BANNER_SUCCESS } from '../constants/actionTypes';

const initialState = {};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANNER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default bannerReducer;
